import { TRouterLink } from "@/models/router";
import { RouteConfig } from "vue-router";
import { REmployeeProfileDocuments } from "./views/Documents/REmployeeProfileDocuments";
import { REmployeeProfileEmployment } from "./views/Employment/REmployeeProfileEmployment";
import { REmployeeProfilePersonalInfo } from "./views/PersonalInfo/REmployeeProfilePersonalInfo";
import { REmployeeProfileCompanyDataHistory } from "./views/DataHistory/REmployeeProfileCompanyDataHistory";

export const REmployeeProfile: RouteConfig = {
  path: "profile",
  component: () =>
    import(
      /* webpackChunkName: "employee-profile" */
      "./VEmployeeProfile.vue"
    ),
  meta: {
    title: "My Profile",
    icon: "person-outline",
    newIcon: "user",
  },
  children: [
    {
      path: "",
      redirect: REmployeeProfilePersonalInfo.path,
    },
    REmployeeProfilePersonalInfo,
    REmployeeProfileEmployment,
    REmployeeProfileDocuments,
    REmployeeProfileCompanyDataHistory,
  ],
};

export const employeeProfileLinks = (REmployeeProfile.children ?? []).reduce(
  (items, { path, meta }) =>
    meta && meta.label
      ? items.concat({
          path: "/" + REmployeeProfile.path + (path ? "/" + path : ""),
          label: meta.label,
          basePath: meta.basePath,
        })
      : items,
  [] as TRouterLink[]
);
